export function saveBlob(blob, name) {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement("a")
  anchor.href = url
  anchor.download = name
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60000)
}

export async function downloadDocument(file) {
  const response = await fetch(file.url)
  if (!response.ok) throw new Error(`No se pudo descargar ${file.nombre}`)
  saveBlob(await response.blob(), file.nombre)
}

export async function buildDocumentsZip(files) {
  const { default: JSZip } = await import("jszip")
  const zip = new JSZip()
  const used = new Set()
  for (const file of files) {
    const response = await fetch(file.url)
    if (!response.ok) throw new Error(`No se pudo descargar ${file.nombre}. Intenta nuevamente.`)
    const base = Array.from(file.nombre || "archivo", char => char.charCodeAt(0) < 32 ? "_" : char)
      .join("").replace(/[\\/<>:"|?*]/g, "_").replace(/^\.+/, "_")
    let name = base
    let index = 2
    while (used.has(name.toLowerCase())) name = `${index++}_${base}`
    used.add(name.toLowerCase())
    zip.file(name, await response.arrayBuffer())
  }
  return zip.generateAsync({ type: "blob" })
}
